<template>
  <div
    class="state-button"
    :class="[readerSlug, { populated, selected }]"
    @click="onClick"
  >
    <slot>&nbsp;</slot>
  </div>
</template>

<script>
  export default {
    props: ['readerId', 'populated', 'selected'],
    methods: {
      onClick() {
        this.$emit('click', this.readerId);
      },
    },
    computed: {
      readerSlug() {
        const color = this.$store.getters.readerColor(this.readerId);
        return `reader-${color}`;
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import '../../variables';

  .state-button {
    // cursor: pointer;
    border-radius: 4px;
    width: 20px;
    height: 20px;
    display: inline-block;
    background-color: $gray-300;
    color: $gray-600;
    margin: 0 3px;
    font-size: 24px;
    line-height: 1.12rem;
    font-weight: 700;
    text-align: center;
    border: 1px solid $gray-400;
    &:first-child {
      margin-left: 0;
    }
    &:last-child {
      margin-right: 0;
    }
    &:hover {
      color: $gray-800;
    }
  }

  .populated.reader-1 {
    background: rgba($reader-1, 0.2);
    border: 1px solid rgba($reader-1, 0.2);
  }
  .populated.reader-2 {
    background: rgba($reader-2, 0.2);
    border: 1px solid rgba($reader-2, 0.4);
  }
  .populated.reader-3 {
    background: rgba($reader-3, 0.2);
    border: 1px solid rgba($reader-3, 0.2);
  }
  .selected.reader-1 {
    background: rgba($reader-1, 0.8);
    border: 1px solid rgba($reader-1, 0.9);
  }
  .selected.reader-2 {
    background: rgba($reader-2, 0.8);
    border: 1px solid rgba($reader-2, 0.9);
  }
  .selected.reader-3 {
    background: rgba($reader-3, 0.8);
    border: 1px solid rgba($reader-3, 0.9);
  }
</style>
